import { render, staticRenderFns } from "./Widgets.vue?vue&type=template&id=0491824a&scoped=true"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0491824a",
  null
  
)

export default component.exports